import { Service } from "@turizi/shared";

export const StayTemplate: Partial<Service> = {
    category: 'stay',
    required_service_orders: 0,

    self_attrs: [
        {
            key: 'home_type',
            type: 'text',
            value: null,
            section: 'info_0',
            sort: 0,
            strong: true,
        },
        {
            key: 'room_type',
            type: 'text',
            value: null,
            section: 'room_1',
            sort: 1,
        },
        {
            key: 'category',
            type: 'text',
            value: null,
            section: 'room_1',
            sort: 2,
        },
        {
            key: 'capacity',
            type: 'text',
            value: null,
            section: 'room_1',
            sort: 3,
        },
        {
            key: 'single_beds',
            type: 'text',
            value: null,
            section: 'beds_1',
            sort: 4,
        },
        {
            key: 'double_beds',
            type: 'text',
            value: null,
            section: 'beds_1',
            sort: 5,
        },
        {
            key: 'bath_private',
            type: 'boolean',
            value: true,
            section: 'bath_1',
            sort: 6,
        },
        {
            key: 'baths_number',
            type: 'text',
            value: null,
            section: 'bath_2',
            sort: 7,
        },
        {
            key: 'bedrooms_number',
            type: 'text',
            value: null,
            section: 'paxs_0',
            sort: 3,
        },
        {
            key: 'jacuzzi',
            type: 'boolean',
            value: false,
            section: 'bath_3',
            sort: 8,
        },
        {
            key: 'spacial_view',
            type: 'text',
            value: null,
            sort: 9,
        },
        {
            key: 'private_room',
            type: 'boolean',
            value: true,
            section: 'info_0',
            sort: 30,
            strong: true,
        }
    ],
    booking_attrs: [
        {
            key: 'room_number',
            type: 'text',
            value: null,
            section: 'room_1',
            sort: 1,
        }
    ]

} as const;

export default StayTemplate;